import { useEffect, useRef } from "react";

// Calls `fn` when the tab/window becomes visible or refocused.
// Applies a simple cooldown (ms) to avoid spamming.
export default function useVisibilityRefresh(fn, { cooldownMs = 5000 } = {}) {
  const lastRun = useRef(0);

  useEffect(() => {
    if (typeof fn !== "function") return;
    function maybeRun() {
      const now = Date.now();
      if (now - lastRun.current < cooldownMs) return;
      lastRun.current = now;
      try { fn(); } catch {}
    }
    function onVisibility() {
      if (document.visibilityState === "visible") maybeRun();
    }
    window.addEventListener("focus", maybeRun, true);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      window.removeEventListener("focus", maybeRun, true);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [fn, cooldownMs]);
}
